const initState ={
    baseOrderInfo:null,
    baseOrderDetail:null,
    suppDueDateInvoked:false,
    suppDueDateAvailable:"NA",
    suppHeader:"",
    isCartUpdatedSupp: false,
    profileBacktoCart:false,
    isCartValidatedSupp: false,
    requestTN:"",
    suppSelectedProds: null,
    profileDTMProductsInfo:[],
    suppProfileCartStatus: {},
    wirelessVisionDetails:null,
 }
 function supp(state = initState, action){
    switch(action.type){
     case 'UPDATE_BASEORDERINFO':
       return Object.assign({}, state, {
        baseOrderInfo: action.value
       })
     case 'UPDATE_BASEORDERDETAIL':
       return Object.assign({}, state, {
         baseOrderDetail: action.value
       })
    case 'SUPP_DUEDATEINVOKED':
       return Object.assign({}, state, {
        suppDueDateInvoked: action.value
       })
    case 'SUPP_DUEDATEAVAILABLE':
       return Object.assign({}, state, {
        suppDueDateAvailable: action.value
       })
    case 'SUPP_HEADER':
       return Object.assign({},state,{
           suppHeader:action.value
       }) 
    case 'UPDATE_CART_SUPP':
        return Object.assign({},state,{
          isCartUpdatedSupp:action.value,
          profileBacktoCart:!action.value,
          isCartValidatedSupp:!action.value
        })
    case 'SUPP_PROFILEBACKTOCART':
        return Object.assign({},state,{
         profileBacktoCart:action.value,
         isCartUpdatedSupp:!action.value,
         isCartValidatedSupp:!action.value,
         suppDueDateAvailable:"NA"
        })
    case 'SUPP_CART_VALIDATED':
         return Object.assign({},state,{
            isCartValidatedSupp:action.value
         }) 
   case 'SUPP_LOADTN':
         return Object.assign({},state,{
            requestTN:action.value
         })
   case 'SUPP_SELECTED_PRODS':
      //let selectedProds = state.suppSelectedProds;
      //selectedProds.push(action.value);
      return Object.assign({},state,{
         suppSelectedProds:action.value
      }) 
      
   case 'UPDATE_PROFILE_DTM_PRODUCTS':
      return Object.assign({},state,{
         profileDTMProductsInfo:action.value
      })
   
   case 'UPDATE_PROFILE_CART_STATUS':
      return Object.assign({},state,{
         suppProfileCartStatus:action.value
      })
   case 'SUPP_VISIONDETAILS':
       return Object.assign({}, state, {
        wirelessVisionDetails: action.value
       })
   default:
         return state
    }
 }
 export default supp;